const lang = process.env.REACT_APP_LANG || 'en';

export default lang;